import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from "vuex";
import { showBModal } from "@Shared/components/bootstrap/BModal";
import { CREATE_CLIENT_PROFILE, CREATE_PROFILE_QUICK_NOTE, CREATE_QUICK_REMINDER, LOAD_BOARD_COLLABORATORS, GET_CLIENT_DUPLICATE } from "@Broker/@Modules/clients/board/store/board-actions";
import { BOARD_OWNER, COLLABORATORS, SELECTED_BOARD } from "@Broker/@Modules/clients/board/store/board-getters";
import { GenericModal } from "@Shared/components/modals";
import BoardSelect from "../../components/boards-select.vue";
import CollaboratorsSelect from "@Shared/components/general/collaborators-select.vue";
import ProfileDetailsForm from "../header-components/profile-details-form";
import QuickActions from "../header-components/quick-actions";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import Amplitude from "@Shared/@Utils/amplitude";
import { uniqBy, values } from "lodash";
import DuplicateClientWarningModal from "./duplicate-client-warning-modal";
import { defineComponent } from "@vue/composition-api";
import { fullNameLowerCase } from "@Shared/@Utils/helpers/text";
export default defineComponent({
  name: "CreateClientModal",
  components: {
    GenericModal,
    BoardSelect,
    CollaboratorsSelect,
    ProfileDetailsForm,
    QuickActions,
    SimpleButton,
    DuplicateClientWarningModal
  },
  data() {
    return {
      boardSelected: null,
      ownerSelected: null,
      quickFollowUp: {
        scheduledDate: "",
        scheduledTime: "",
        description: "",
        assignees: []
      },
      note: "",
      ownerSelectLoading: false,
      buttonIsLoading: false,
      loadedSuccessfully: true,
      profilesFound: [],
      profileDetails: {},
      isDetailsValid: false,
      invalidNote: true,
      invalidReminder: true,
      loadingCollaborators: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("AccountStore", ["userDetails"])), mapState("BoardStore", ["selectedBoardId"])), mapGetters("BoardStore", [COLLABORATORS, BOARD_OWNER, SELECTED_BOARD])), {}, {
    boardId() {
      return this.boardSelected || this.selectedBoardId;
    },
    collaborators() {
      if (!this.boardId) return [];
      const collaboratorsById = this.COLLABORATORS(this.boardId);
      const collaboratorsArray = values(collaboratorsById);
      if (collaboratorsById[this.userDetails.username]) return collaboratorsArray;
      return [...collaboratorsArray, this.userDetails];
    },
    collaboratorsWithOwner() {
      return uniqBy([...this.collaborators, this.BOARD_OWNER], "username");
    }
  }),
  watch: {
    boardId(val) {
      this.loadCollaborators(val);
    }
  },
  mounted() {
    this.ownerSelected = this.userDetails.username;
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [LOAD_BOARD_COLLABORATORS, CREATE_CLIENT_PROFILE, CREATE_PROFILE_QUICK_NOTE, CREATE_QUICK_REMINDER, GET_CLIENT_DUPLICATE])), {}, {
    changeBoard({
      id
    }) {
      this.boardSelected = id;
    },
    changeOwner({
      username
    }) {
      this.ownerSelected = username;
    },
    async loadCollaborators(boardId) {
      this.loadingCollaborators = true;
      await this.LOAD_BOARD_COLLABORATORS({
        boardId
      });
      this.loadingCollaborators = false;
    },
    async checkMatchingCase(profiles) {
      // Add matching case to each profile found and append it to profilesFound array
      const profilesWithMatchingCase = _filterInstanceProperty(profiles).call(profiles, profile => {
        if (fullNameLowerCase(profile) === fullNameLowerCase(this.profileDetails) && this.profileDetails.email && profile.email === this.profileDetails.email) {
          profile.matchingCase = "email&fullName";
          return profile;
        } else if (fullNameLowerCase(profile) === fullNameLowerCase(this.profileDetails)) {
          profile.matchingCase = "fullName";
          return profile;
        } else if (this.profileDetails.email && profile.email === this.profileDetails.email) {
          profile.matchingCase = "email";
          return profile;
        }
      });
      this.profilesFound = profilesWithMatchingCase;
      if (this.profilesFound.length == 0) {
        await this.createClient();
      } else {
        showBModal("duplicate-client-warning-modal", {}, this);
      }
    },
    async createClientModal() {
      if (!this.isDetailsValid) return;
      try {
        this.buttonIsLoading = true;
        const duplicate = {
          givenName: this.profileDetails.givenName,
          familyName: this.profileDetails.familyName,
          email: this.profileDetails.email,
          active: this.profileDetails.active,
          agentUsername: this.profileDetails.agentUsername
        };
        const hasDuplicate = await this.GET_CLIENT_DUPLICATE(duplicate);
        if (hasDuplicate.profiles.length !== 0) {
          await this.checkMatchingCase(hasDuplicate.profiles);
        } else await this.createClient();
      } catch (e) {
        this.buttonIsLoading = false;
      }
    },
    async createClient() {
      const data = _objectSpread({
        ownerUsername: this.ownerSelected
      }, this.profileDetails);
      const clientProfileId = await this.CREATE_CLIENT_PROFILE({
        data,
        boardId: this.boardId
      });
      if (!this.invalidNote) {
        await this.CREATE_PROFILE_QUICK_NOTE({
          clientProfileId,
          note: this.note
        });
      }
      if (!this.invalidReminder) {
        await this.CREATE_QUICK_REMINDER({
          clientProfileId,
          reminder: this.quickFollowUp
        });
      }
      this.buttonIsLoading = false;
      this.$hideModal();
      this.$router.push({
        name: "client-profile",
        params: {
          clientProfileId,
          boardId: this.boardId
        }
      });
    },
    stopLoading() {
      this.buttonIsLoading = false;
      this.loadedSuccessfully = false;
    },
    updateQuickActions(type, data) {
      switch (type) {
        case "follow-up":
          this.quickFollowUp = _objectSpread({}, data);
          break;
        case "note":
          this.note = data;
          break;
      }
    },
    handleValidationChange(type, isValid) {
      if (type === "follow-up") {
        this.invalidReminder = !isValid;
        return;
      }
      if (type === "note") {
        this.invalidNote = !isValid;
        return;
      }
    },
    updateProfileDetails(profileDetails, isValid) {
      this.profileDetails = profileDetails;
      this.isDetailsValid = isValid;
    },
    resetFields() {
      this.quickFollowUp = {
        scheduledDate: "",
        scheduledTime: "",
        description: "",
        assignees: []
      };
      this.note = "";
      this.invalidNote = true;
      this.invalidReminder = true;
      this.isDetailsValid = false;
    },
    handleShow() {
      this.boardSelected = this.selectedBoardId;
      this.ownerSelected = this.userDetails.username;
      Amplitude.logEvent("Board - add client visited");
    }
  })
});